module.exports = __webpack_public_path__ + "img/hsin-tung-yang.cfa90b15.jpg";